import httpClient from "./httpClient";

const entityEndpoint = "/extras";

export default {
  async getAll() {
    const response = await httpClient.get(entityEndpoint);
    return response.data;
  },

  async delete(id) {
    const response = await httpClient.delete(`${entityEndpoint}/${id}`);
    return response.data;
  },

  async create(extra) {
    const response = await httpClient.post(entityEndpoint, {
      ...extra
    });
    return response.data;
  },

  async update(extra) {
    const response = await httpClient.put(`${entityEndpoint}/${extra.id}`, {
      ...extra
    });
    return response.data;
  },

  async deleteOption(extra, option) {
    const response = await httpClient.delete(
      `${entityEndpoint}/${extra.id}/options/${option.id}`
    );
    return response.data;
  }
};
